import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToWaitlist = () => {
    const element = document.getElementById('waitlist');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-teal-50 via-white to-blue-50">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4ec88618ed11da6f09b00ac0fa9ec853.jpg"
          alt="CleanerConnect Hero"
          className="w-full h-full object-cover object-top opacity-20"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div
          className={`transition-all duration-1000 transform ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <h1 className="text-6xl md:text-7xl font-bold text-teal-900 mb-6 leading-tight">
            Simplify Your Vacation<br />Rental Turnovers
          </h1>
          
          <p className="text-2xl text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
            Never Stress About Turnovers Again.<br />
            Automated scheduling, synced calendars, and reliable cleaners — all in one place.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6 mb-12 max-w-4xl mx-auto">
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
              <span className="text-lg font-medium">Built for Airbnb &amp; VRBO hosts</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
              <span className="text-lg font-medium">Trusted by property managers</span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto mb-12">
            <div className="flex flex-col items-center justify-center gap-3 bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg">
              <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-gray-800 text-center">Automated Turnover Scheduling</span>
            </div>
            
            <div className="flex flex-col items-center justify-center gap-3 bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg">
              <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-gray-800 text-center">Instant Turnover Alerts</span>
            </div>
            
            <div className="flex flex-col items-center justify-center gap-3 bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg">
              <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-gray-800 text-center">Verified Platform You Trust</span>
            </div>
            
            <div className="flex flex-col items-center justify-center gap-3 bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg">
              <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-gray-800 text-center">Manage All Properties in One Place</span>
            </div>
          </div>

          <button
            onClick={scrollToWaitlist}
            className="bg-teal-600 hover:bg-teal-700 text-white px-12 py-5 rounded-xl text-xl font-bold transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Join the Waitlist
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-teal-600 text-3xl"></i>
      </div>
    </section>
  );
}
